module.exports = __webpack_public_path__ + "media/images/pc/top/soudan_online-10c449fc217bf65bb4cdd8b4a1822438.jpg";